import { AxiosInstance, AxiosPromise } from 'axios';
import { LegacyInvoice } from '../../../../types/Accounting';
import { GetBillInvoicesByJobResponse, InvoiceEndpoint } from './InvoiceServices.types';
import { LineService } from './LineService/LineService';
import { LineFormValues } from '../../../../../order/view/ledger/components/components/add-charges-form-container/components/add-charges-form';

export class InvoiceServices implements InvoiceEndpoint {
  instance: AxiosInstance;
  line: LineService;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.line = new LineService(instance);
  }

  getBillInvoicesByOrder(orderGuid: string): AxiosPromise<GetBillInvoicesByJobResponse> {
    return this.instance.get(`/invoice/order/${orderGuid}`);
  }

  getBillInvoicesByJob(jobGuid: string) {
    return this.instance.get(`/invoice/job/${jobGuid}`);
  }

  createInvoice(
    orderGuid: string,
    accountGuid: string,
    relation: 'client' | 'consignee' | 'referrer' | 'vendor' | 'carrier',
  ): AxiosPromise<Pick<LegacyInvoice, 'guid'>> {
    return this.instance.post('/invoice', {
      order: { guid: orderGuid },
      account: { guid: accountGuid },
      relation,
    });
  }

  addLine(
    account: Pick<LegacyInvoice, 'guid'>,
    values: Omit<LineFormValues, 'billOrInvoiceGuid'>,
  ): AxiosPromise<any> {
    return this.instance.post(`/invoice/${account.guid}/line`, values);
  }

  updateLine(
    account: Pick<LegacyInvoice, 'guid'>,
    lineGuid: string,
    values: Omit<LineFormValues, 'billOrInvoiceGuid'>,
  ): AxiosPromise<any> {
    return this.instance.put(`/invoice/${account.guid}/line/${lineGuid}`, values);
  }

  deleteLine(invoiceGuid: string, lineGuid: string): AxiosPromise<any> {
    return this.instance.delete(`/invoice/${invoiceGuid}/line/${lineGuid}`);
  }

  deleteLines(accountGuid: string, linesGuid: string[]): AxiosPromise<any> {
    return this.instance.delete(`/invoice/${accountGuid}/lines`, {
      data: linesGuid,
    });
  }

  exportLines(accountGuid: string, linesGuid: string[]) {
    return this.instance.put(`/invoices/${accountGuid}/export`, {
      lines: linesGuid,
    });
  }
}
